// Stable per-device identifier: persistent random id + lightweight fingerprint.
export function getDeviceId() {
  try {
    let id = localStorage.getItem("device_id");
    if (!id) {
      const fp = [
        navigator.userAgent,
        navigator.language,
        navigator.platform,
        `${window.screen.width}x${window.screen.height}`,
        new Date().getTimezoneOffset(),
      ].join("|");
      let h = 0;
      for (let i = 0; i < fp.length; i++) h = (h * 31 + fp.charCodeAt(i)) >>> 0;
      id = `${h.toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("device_id", id);
    }
    return id;
  } catch {
    return null;
  }
}
